module.exports = __webpack_public_path__ + "static/logo-3eb85384a79e758c65a6a10cc232e2d0.png";